import React from "react";
import { Outlet } from "react-router-dom";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/sidebar/Sidebar";
import Main from "../components/Main";
import Navbar from "../components/navbar/Navbar";
import Content from "../components/Content";
import Footer from "../components/Footer";

import dashboardItems from "../components/sidebar/dashboardItems";

const Dashboard = ({ children }) => (
  <React.Fragment>
    <Wrapper>
      <Sidebar items={dashboardItems} />
      <Main>
        <Navbar />
        <div style={{
          backgroundColor: "#fff3cd",
          border: "1px solid #ffecb5",
          color: "#664d03",
          padding: "12px 20px",
          margin: "12px",
          borderRadius: "4px",
          textAlign: "center"
        }}>
          <strong>Let op:</strong> Deze portal is niet meer actueel. Graag de nieuwe portal gebruiken:{" "}
          <a href="https://beta.y-con.nl" target="_blank" rel="noopener noreferrer" style={{ color: "#664d03", fontWeight: "bold" }}>
            https://beta.y-con.nl
          </a>
        </div>
        <Content>
          {children}
          <Outlet />
        </Content>
        <Footer />
      </Main>
    </Wrapper>
  </React.Fragment>
);

export default Dashboard;
